module.exports = __webpack_public_path__ + "img/zndyh.b1d67f9d.jpg";